import { debounce, isEqual } from "lodash-es";
import { LabelHTMLAttributes, forwardRef, useEffect, useMemo, useState } from "react"
import { LiaTimesSolid, LiaCheckSolid } from "react-icons/lia";

type Label = string | { label: string, value: string }

export interface MultiselectInputProps extends LabelHTMLAttributes<HTMLLabelElement> {
    optionLabels: Label[]
    onChange?: (labels: Label[]) => void
    label?: string | React.ReactNode
    value?: Label[]
    timeout?: number
}

export const MultiselectInput = forwardRef(({ optionLabels, label, value = [], onChange, timeout = 1000, label: strLabel, className, ...rest }: MultiselectInputProps, ref) => {
    const [labels, setLabels] = useState<Label[]>([])
    const [_value, setValue] = useState<string>('')

    const addLabel = (label: Label) => setLabels(labels.concat(label))
    const rmLabel = (label: Label) => setLabels(labels.filter(l => l != label))

    const filtedOptions = optionLabels.filter(l => typeof l == 'string' ? l.includes(_value) : l.value.includes(_value))

    const f = useMemo(() => debounce((value) => {
        onChange?.(value)
    }, timeout), [onChange])

    useEffect(() => {
        f.cancel()
        f(labels)
    }, [labels])

    useEffect(() => {
        if (!isEqual(value, labels))
            setLabels(value)
    }, [value])

    return <label className={`input flex items-center gap-2 dropdown dropdown-bottom ${className ?? ''}`} {...rest}>
        <div tabIndex={0} className="flex items-center overflow-x-auto scrollbar-thin">
            {strLabel}
            {labels.map(label => <span key={label.toString()} className="badge badge-primary mx-1">
                {typeof label == 'string' ? label : label.label}
                <LiaTimesSolid className="cursor-pointer" onClick={() => rmLabel(label)} />
            </span>)}
            <input type="text" className="w-full h-full" value={_value} onChange={e => setValue(e.target.value)} />
        </div>
        <ul tabIndex={0} className="dropdown-content menu bg-base-100 rounded-box z-1 w-52 p-2 shadow">
            {filtedOptions.map(label => <li key={label.toString()}>
                <a
                    className={`rounded-none ${labels.includes(label) ? 'bg-primary' : ''}`}
                    onClick={() => labels.includes(label) ? rmLabel(label) : addLabel(label)}>
                    {typeof label == 'string' ? label : label.label}
                    {labels.includes(label) && <LiaCheckSolid className="ml-auto" />}
                </a>
            </li>)}
        </ul>
    </label >
})